import { z } from 'zod';
import { IdSchema, PhoneSchema, nullableText, optionalText, requiredText } from './common.js';
/* =============================== Hudud ================================= */
export const RegionResponseSchema = z.object({
    id: IdSchema,
    code: z.string(),
    nameUz: z.string(),
    nameRu: nullableText(80),
    sort: z.number().int(),
    isActive: z.boolean(),
});
/* ================================ Do'kon =============================== */
export const ShopResponseSchema = z.object({
    id: IdSchema,
    code: z.string(),
    nameUz: z.string(),
    nameRu: nullableText(120),
    regionId: IdSchema,
    addressUz: z.string(),
    addressRu: nullableText(255),
    phone: nullableText(20),
    hoursUz: nullableText(120),
    hoursRu: nullableText(120),
    lat: z.number().nullable(),
    lng: z.number().nullable(),
    hasCourier: z.boolean(),
    hasPickup: z.boolean(),
    isActive: z.boolean(),
    sort: z.number().int(),
});
export const CreateShopSchema = z
    .object({
    code: z
        .string()
        .trim()
        .min(1)
        .max(32)
        .regex(/^[A-Z0-9_]+$/, 'Kod FAQAT_KATTA_HARF_VA_PASTKI_CHIZIQ'),
    regionId: IdSchema,
    nameUz: requiredText(120),
    nameRu: optionalText(120),
    addressUz: requiredText(255),
    addressRu: optionalText(255),
    phone: PhoneSchema.optional(),
    hoursUz: optionalText(120),
    hoursRu: optionalText(120),
    lat: z.number().min(-90).max(90).optional(),
    lng: z.number().min(-180).max(180).optional(),
    hasCourier: z.boolean().default(true),
    hasPickup: z.boolean().default(true),
    sort: z.number().int().min(0).max(9999).optional(),
})
    .strict();
export const UpdateShopSchema = CreateShopSchema.partial()
    .extend({ isActive: z.boolean().optional() })
    .strict();
/* =========================== Yetkazish zonasi ========================== */
/**
 * Zonada NARX YO'Q — faqat xizmat nomi va taxminiy muddat.
 * Yetkazish shartini operator telefonda kelishadi (docs/02-MAHSULOT.md).
 */
export const DeliveryZoneResponseSchema = z.object({
    id: IdSchema,
    nameUz: z.string(),
    nameRu: nullableText(80),
    serviceUz: z.string(),
    serviceRu: nullableText(80),
    etaUz: z.string(),
    etaRu: nullableText(40),
    isFallback: z.boolean(),
    isActive: z.boolean(),
    sort: z.number().int(),
    regionIds: z.array(IdSchema),
});
export const CreateDeliveryZoneSchema = z
    .object({
    nameUz: requiredText(80),
    nameRu: optionalText(80),
    serviceUz: requiredText(80),
    serviceRu: optionalText(80),
    etaUz: requiredText(40),
    etaRu: optionalText(40),
    isFallback: z.boolean().default(false),
    sort: z.number().int().min(0).max(9999).optional(),
    regionIds: z.array(IdSchema).default([]),
})
    .strict();
export const UpdateDeliveryZoneSchema = CreateDeliveryZoneSchema.partial()
    .extend({ isActive: z.boolean().optional() })
    .strict();
/* =============================== Manzil ================================ */
export const AddressResponseSchema = z.object({
    id: IdSchema,
    label: nullableText(40),
    line: z.string(),
    landmark: nullableText(120),
    isDefault: z.boolean(),
});
export const CreateAddressSchema = z
    .object({
    label: optionalText(40),
    line: requiredText(255),
    landmark: optionalText(120),
    isDefault: z.boolean().default(false),
})
    .strict();
export const UpdateAddressSchema = CreateAddressSchema.partial().strict();
//# sourceMappingURL=geo.js.map